import axios from 'axios';

const api =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ? axios.create({
        baseURL: 'http://192.168.1.85:3333', // dev - rede desenvolvimento
        // baseURL: 'https://192.168.1.42:3333', // dev - rede tecnicos
      })
    : axios.create({
        baseURL: 'https://panterafood.com.br:21000', // producao
      });
export default api;
